import {
  FETCH_SNIPPETS_SUCCESS,
  FETCH_SNIPPETS_FAILED
} from "../types/snippets";

const initialState = {};

export default function(state = initialState, action) {
  switch (action.type) {
    case FETCH_SNIPPETS_SUCCESS:
      return {
        ...state,
        data: action.snippets
      };
    case FETCH_SNIPPETS_FAILED:
      return {
        ...state
      };
    default:
      return state;
  }
}
